import { createCoursesApi } from '@e-learning/core';
import { api } from '../../../../api/client';

const coursesApi = createCoursesApi(api);

/**
 * Hook para gestão de cursos no B2B.
 * Usa a API do core com o cliente configurado para B2B.
 */
export function useCourses() {
  return {
    fetchCourses: coursesApi.fetchCourses,
    fetchCourseCategories: coursesApi.fetchCourseCategories,
    fetchCourseStatus: coursesApi.fetchCourseStatus,
    fetchCourseById: coursesApi.fetchCourseById,
    fetchCourseModules: coursesApi.fetchCourseModules,
    fetchModuleLesson: coursesApi.fetchModuleLesson,
    createCourse: coursesApi.createCourse,
    updateCourse: coursesApi.updateCourse,
    updateCourseStatus: coursesApi.updateCourseStatus,
    archiveCourse: coursesApi.archiveCourse,
    uploadCourseCover: coursesApi.uploadCourseCover,
    createModule: coursesApi.createModule,
    updateModule: coursesApi.updateModule,
    createModuleLesson: coursesApi.createModuleLesson,
    updateModuleLesson: coursesApi.updateModuleLesson,
    updateCourseModulesDisplayOrder: coursesApi.updateCourseModulesDisplayOrder,
    updateCourseModuleLessonsDisplayOrder: coursesApi.updateCourseModuleLessonsDisplayOrder,
    deleteCourseModuleLessonFile: coursesApi.deleteCourseModuleLessonFile,
    uploadCourseModuleLessonFile: coursesApi.uploadCourseModuleLessonFile,
    updateQuizConfigQuestions: coursesApi.updateQuizConfigQuestions,
    fetchTargetingGroups: coursesApi.fetchTargetingGroups,
    fetchTargetingUsers: coursesApi.fetchTargetingUsers,
    updateCourseAudience: coursesApi.updateCourseAudience,
  };
}
